export default __webpack_public_path__ + "static/media/cherry_tomatoes.b58a0e45.png";